<app-period-display [value]="value" (click)="openDialog()" [opening]="opening"></app-period-display>
